import React from 'react'

import ArrowForward from '@mui/icons-material/ArrowForward'
import { Box, Button, Grid, Link, Typography } from '@mui/material'
import { PRIVACY_POLICY, SLALOM_LOGO_LINK, SUPPORT } from 'constants/routes'

import SealAndLogo from 'assets/images/Group 264.svg'

import { styles } from './Footer.styles'

export const TEST_ID = 'footer'

const CopyrightContainer = () => (
	<Grid
		data-testid={`${TEST_ID}-copyright`}
		item
		sx={styles.CopyrightContainer}
	>
		<Grid item sx={styles.CopyrightInnerGrid}>
			<Box>
				<Typography
					data-testid={`${TEST_ID}-copyright-text`}
					variant="body2"
					mr={1}
					sx={styles.responsiveTextSize}
				>
					{`©${new Date().getFullYear()} Slalom, Inc`}
				</Typography>
			</Box>
			<Box>
				<Link
					color="inherit"
					data-testid={`${TEST_ID}-privacy-policy-link`}
					href={PRIVACY_POLICY}
					target="_blank"
				>
					<Typography sx={styles.responsiveTextSize} variant="body2">
						Privacy Policy
					</Typography>
				</Link>
			</Box>
		</Grid>
	</Grid>
)

const CenterSection = () => (
	<Grid container sx={{ ...styles.centerSectionGrid }}>
		<Grid item sx={styles.CenterSectionContainerAlternative}>
			<Box>
				<Typography sx={styles.platformTypography} variant="body2">
					For quick platform guidance:
				</Typography>
			</Box>
			<Box>
				<Button
					color="secondary"
					data-testid={`${TEST_ID}-faq-cta-button`}
					endIcon={
						<ArrowForward
							color="secondary"
							data-testid={`${TEST_ID}-cta_button-arrow`}
						/>
					}
					href={SUPPORT}
					target="_blank"
					sx={styles.ActionLink}
					variant="text"
				>
					FAQs & SUPPORT
				</Button>
			</Box>
		</Grid>
		<Grid item sx={styles.CenterSectionContainer}>
			<Box>
				<Typography sx={styles.platformTypography} variant="body2">
					To inform our product roadmap:
				</Typography>
			</Box>
			<Box>
				<Button
					color="secondary"
					data-testid={`${TEST_ID}-feature-cta-button`}
					endIcon={
						<ArrowForward
							color="secondary"
							data-testid={`${TEST_ID}-cta_button-arrow`}
						/>
					}
					href="https://go.slalom.com/feature-request"
					target="_blank"
					sx={styles.ActionLink}
					variant="text"
				>
					Request a feature
				</Button>
			</Box>
		</Grid>
		<Grid item sx={styles.CenterSectionContainerAlternative}>
			<Box>
				<Typography sx={styles.platformTypography} variant="body2">
					For workshop facilitation support:
				</Typography>
			</Box>
			<Box>
				<Button
					color="secondary"
					data-testid={`${TEST_ID}-cta-button`}
					endIcon={
						<ArrowForward
							color="secondary"
							data-testid={`${TEST_ID}-cta_button-arrow`}
						/>
					}
					href="https://go.slalom.com/brainstorm-support"
					target="_blank"
					sx={styles.ActionLink}
					variant="text"
				>
					Let&rsquo;s Connect
				</Button>
			</Box>
		</Grid>
	</Grid>
)

const LogoContainer = () => (
	<Grid data-testid={`${TEST_ID}-logos`} item sx={styles.LogosContainer}>
		<Box data-testid={`${TEST_ID}-logos-text`}>
			<Typography sx={styles.responsiveTextSize} variant="body2">
				Brought to you by:
			</Typography>
			<Typography sx={styles.responsiveTextSize} variant="body2">
				Slalom&rsquo;s ARC Labs
			</Typography>
		</Box>
		<Box sx={styles.LogoImages}>
			<Link
				href={SLALOM_LOGO_LINK}
				color="inherit"
				target="_blank"
				data-testid={`${TEST_ID}-logos-img`}
			>
				<img alt="Slalom Logo" src={SealAndLogo as unknown as string} />
			</Link>
		</Box>
	</Grid>
)

const Footer = () => {
	return (
		<Grid
			container
			data-testid={`${TEST_ID}`}
			sx={styles.FooterContainer}
			direction={{ xs: 'column', sm: 'row', md: 'row' }}
		>
			<CenterSection />
			<CopyrightContainer />
			<LogoContainer />
		</Grid>
	)
}

export default Footer
